var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5C4.48 0.5 0 4.98 0 10.5C0 16.02 4.48 20.5 10 20.5C15.52 20.5 20 16.02 20 10.5C20 4.98 15.52 0.5 10 0.5ZM14.64 7.3C14.49 8.88 13.84 12.72 13.51 14.49C13.37 15.24 13.09 15.49 12.83 15.52C12.25 15.57 11.81 15.14 11.25 14.77C10.37 14.19 9.87 13.83 9.02 13.27C8.03 12.62 8.67 12.26 9.24 11.68C9.39 11.53 11.95 9.2 12 8.99C12.0069 8.95819 12.006 8.92517 11.9973 8.8938C11.9886 8.86244 11.9724 8.83367 11.95 8.81C11.89 8.76 11.81 8.78 11.74 8.79C11.65 8.81 10.25 9.74 7.52 11.58C7.12 11.85 6.76 11.99 6.44 11.98C6.08 11.97 5.4 11.78 4.89 11.61C4.26 11.41 3.77 11.3 3.81 10.95C3.83 10.77 4.08 10.59 4.55 10.4C7.47 9.13 9.41 8.29 10.38 7.89C13.16 6.73 13.73 6.53 14.11 6.53C14.19 6.53 14.38 6.55 14.5 6.65C14.6 6.73 14.63 6.84 14.64 6.92C14.63 6.98 14.65 7.16 14.64 7.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.21e8e65937dac044ca17e6deb455e9cc.svg";
export { ForwardRef as ReactComponent };